
export const prototypeName = 'Servicebund.RodeoSteakDe:Component.LinkList';